<template>
  <div class="nkdList">
    <div class="listItem" v-for="(item,index) in msgList">
      <div class="appointmentTime">
        预约时间：{{item.appointment_date}} {{item.appointment_time}}
      </div>
      <div class="listItemMsg">
        <div class="user">
          <span>被检测人：</span>
          <span>{{item.full_name}}<small style="color: #666">({{item.id_card}})</small></span>
        </div>
        <div class="msg">
          <span>检测机构：</span>
          <span>深圳核子华曦医学检验实验室</span>
        </div>
        <div class="msg">
          <span>检测地址：</span>
          <span>{{item.collection_address}}</span>
        </div>
        <div class="msg">
          <span>类型：</span>
          <span>{{item.type_name}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import storage from "../../model/storage";
    import qs from "qs";

    export default {
      name: "nkdList",
      data() {
        return {
          msgList: []
        }
      },

      // created() {
      //   let _this = this
      //   let authUser =  storage.get('authUser')
      //   console.log(authUser)
      //   if (!authUser) {
      //     const {state,code,mangerId,storeId} = qs.parse(location.href.split('?')[1]) || {};
      //     console.log(location.href)
      //     console.log('state:',state,'code:',code)
      //     if(state && code) {
      //       console.log('state:',state,'code:',code)
      //       this.$axios.get("https://wx.hezijiyin.com/api/wechat/user/profile",{
      //         params: {
      //           state: state,
      //           code: code
      //         }
      //       }).then(responseJson => {
      //         console.log(responseJson.data.token)
      //         storage.set('token',responseJson.data.token)
      //         storage.set('authUser',1)
      //         this.$router.push({
      //           path: '/nkd_list',
      //           name: 'nkdList'
      //         });
      //       })
      //     }else{
      //       console.log('第一次')
      //       //第一次
      //       const locationHref = location.href
      //       const baseUrl = 'https://wx.hezijiyin.com/api'
      //       console.log(locationHref,baseUrl)
      //       let url = `${baseUrl}/wechat/user/login?redirect_uri=${encodeURIComponent(locationHref)}`
      //       console.log(url)
      //       location.href = `${baseUrl}/wechat/user/login?redirect_uri=${encodeURIComponent(locationHref)}`
      //     }
      //
      //   }
      //   // 正式环境
      //   // let url = 'https://wx.hezijiyin.com/api/order/appointment/index'
      //   // 测试环境
      //   // let url = 'https://wx.hezijiyin.com/api/order/appointment/index'
      //   this.$axios.get('https://admin.hxyljk.com/public/api.php/order/appointment/index',
      //     {headers: {
      //       'Authorization': 'bearer' + storage.get('token'),
      //     }}
      //   ).then(function(res){
      //     let msgList = res.data.data
      //     for (let item of msgList) {
      //       console.log(item)
      //       let appointment_date = item.appointment_date  //从后台获取的时间戳
      //       let date = new Date(appointment_date * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      //       let Y = date.getFullYear() + '/';
      //       let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/';
      //       let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() + ' ';
      //       item.appointment_date = Y + M + D
      //
      //     }
      //     _this.msgList = msgList
      //   })
      //     .catch(function(error){
      //       console.log(error)
      //     })
      // },

    }
</script>

<style scoped>
  .nkdList{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow-y: auto;
    background-color: #f0f0f0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px 0;
  }
  .listItem {
    width: 86%;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    box-shadow: 0 0.02133rem 0.128rem 0 rgba(0,0,0,.15);
    margin-bottom: 15px;
  }
  .appointmentTime {
    font-size: 13px;
    color: #8b8891;
    height: 30px;
    border-bottom: 1px solid rgb(239, 239, 244);
    margin-bottom: 15px;
  }
  .user{
    height: 25px;
    line-height: 25px;
  }
  .msg {
    color: #666;
    height: 25px;
    line-height: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/views/nkd/nkdList.vue